import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Directive({
  selector: '[appShowForAuthenticatedUser]'
})
export class ShowForAuthenticatedUserDirective {

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private authService: AuthService
  ) {
    this.setVisibility();
    this.authService.isLogged$.subscribe(() => {
      this.setVisibility();
    })
  }

  ngOnChanges(): void {
    this.setVisibility();
  }

  private setVisibility(): void {
    const loggedIn = this.authService.isLogedIn();
    if (loggedIn) {
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'block');
    } else {
      this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
    }
  }

}
